import '.././styles/Footer.css'
const Footer = () =>
{
  return (
    <div className='foot'>
      <p>	&copy;Bun Jak Sin</p>
    </div>
  );

};
export default Footer;